export const topBarHeight = 64;
export const sideNavWidth = 280;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
export const dateFormat = 'YYYY-MM-DD';
export const ADMIN_ROLE = 101915236;
export const CUSTOMER_WATER_CONSUMPTION_PRIVATE_PATH =
  '/secure/563bff7223f61423eaa526fc36707a0cd1f4fa6d38f61f8f87cdf3959cb4218e';
